import { render, staticRenderFns } from "./PollTab.vue?vue&type=template&id=fbe73cd6&scoped=true&"
import script from "./PollTab.vue?vue&type=script&lang=js&"
export * from "./PollTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fbe73cd6",
  null
  
)

export default component.exports